import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Col,
  Row,
  Button,
  Card,
  Tag,
  Input,
  Typography,
  List,
  Avatar,
} from "antd";
import Slider from "react-slick";
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TextArea from 'antd/lib/input/TextArea';
import ReactPlayer from "react-player";
import { NotificationContainer, NotificationManager } from "react-notifications";
import "react-notifications/lib/notifications.css";
import {
   FacebookOutlined,
   InstagramOutlined,
   TwitterOutlined,
   YoutubeOutlined,
   LinkedinOutlined,
   LeftOutlined,
} from "@ant-design/icons";
import { PDFObject } from 'react-pdfobject'

import PinterestIcon from "./Pinterest";


import DetailCard from './DetailCard'
import PdfPreview from './PdfPreview'
import ProductPreview from './productPreview'
import { SvgProductIcon, SvgLinkIcon, SvgPdfIcon, SvgVideoIcon } from '../common/SvgIcons';
import ReCAPTCHA from "react-google-recaptcha";
import { useSelector } from 'react-redux';
import '../../less/companyInfo.less';

export const Info = (props) => {
   let tagsData = {}
   !_isEmpty(props.tagsInfo) && props.tagsInfo.forEach(item => {
      tagsData = { ...tagsData, [item.id]: item }
   })
   let website = props.Website && props.Website.includes('http') ? props.Website : "https://" + props.Website
   return <div className='gx-pl-2'>
      <Row>
         <Col span={23} >
            <Row>
               <Col span={24}>
                  {
                     props?.CompLogo &&
                     <div>
                        <img
                           src={props?.CompLogo}
                           alt="no img"
                           style={{ maxHeight: 300, height: '45%', maxWidth: '45%' }}
                        />
                     </div>
                  }
               </Col>
            </Row>
            <Row>
               <Col xs={16}>
                  {props.Companyname &&
                     <h1
                        className="gx-mb-2 gx-mt-4 gx-text-black"
                        style={{ fontWeight: 500 }}
                     >
                        {props?.Companyname}
                     </h1>}
               </Col>
               <Col xs={8}>
                  {console.log(props.SocialLinksObject)}
                  <div className="gx-mt-3"> {!!(props && props?.SocialLinksObject && typeof props.SocialLinksObject != "string" &&
                     props.SocialLinksObject.length > 0) && props.SocialLinksObject.map((item) => (
                        <span key={item.type}> {item.type
                           == "facebook" && (
                              <a href={item.url} target="_blank" style={{ color: "black", fontSize: 25, padding: 3, }}>
                                 <FacebookOutlined className={"exhibSocialIcon " + item.type} />
                              </a>)}
                           {item.type == "instagram" && (<a href={item.url} target="_blank" style={{ color: "black", fontSize: 25, padding: 3 }}>
                              <InstagramOutlined className={"exhibSocialIcon " + item.type} />
                           </a>)}
                           {item.type == "linkedin" && (<a href={item.url} target="_blank" style={{ color: "black", fontSize: 25, padding: 3 }}>
                              <LinkedinOutlined className={"exhibSocialIcon " + item.type} />
                           </a>)}
                           {item.type == "youtube" && (<a href={item.url} target="_blank" style={{ color: "black", fontSize: 25, padding: 3 }}>
                              <YoutubeOutlined className={"exhibSocialIcon " + item.type} />
                           </a>)}
                           {item.type == "twitter" && (<a href={item.url} target="_blank" style={{ color: "black", fontSize: 25, padding: 3 }}>
                              <TwitterOutlined className={"exhibSocialIcon " + item.type} />
                           </a>)}
                           {item.type == "pinterest" && (<a href={item.url} target="_blank" style={{ color: "black", fontSize: 25, padding: 3 }}>
                              <PinterestIcon className={"exhibSocialIcon " + item.type} />
                           </a>)}
                        </span>
                     ))}
                  </div>
               </Col>
            </Row>
            {props.supportLevel && <Row>
               <Col span={24}>
                  <h3 className="gx-my-4 app-text-color">
                     SUPPORT LEVEL <span className="gx-text-grey gx-ml-3 f-15">{props?.support_level}</span>
                  </h3>
               </Col>
            </Row>}
            {props.Website &&
               <Row>
                  <Col span={24}>
                     <h3 className="gx-my-4 app-text-color">
                        WEBSITE: <span className="gx-text-grey"><a href={website} target="_blank">{website}</a></span>
                     </h3>
                  </Col>
               </Row>}
            {props?.Country &&
               <Row>
                  <Col span={24}>
                     <h3 className="gx-my-4 app-text-color">
                        COUNTRY <span className="gx-text-grey gx-ml-3 f-15">{props?.Country}</span>
                     </h3>
                  </Col>
               </Row>}
            {!props.supportLevel && <Row>
               <Col span={24}>
                  {!!props.tags && props.tags.length > 0 &&
                     <div className="ant-row-flex">
                        <div className="gx-col-full gx-my-4" style={{ zIndex: 9 }}>
                           {props.tags.map((tag, index) => {
                              return (
                                 <Tag key={index} className="gx-my-1 card-border-radius tag-content">{tagsData[tag]?.label}</Tag>
                              );
                           })}
                        </div></div>
                  }
               </Col>
            </Row>}
            {props.Description &&
               <Row>
                  <Col span={24}>
                     <h3 className="gx-my-4 app-text-color">
                        DESCRIPTION
                     </h3>
                     <div dangerouslySetInnerHTML={{ __html: props.Description }} className="gx-text-grey f-15" />
                  </Col>
               </Row>}
         </Col>
      </Row></div>
}


export const Resources = (props) => {
   const { media } = props
   const [isPdf, setIsPdf] = useState(false);
   const [pdfUrl, setPdfUrl] = useState("");
   const [numPages, setNumPages] = useState(0);
   const [ProductPrev, setProductPreview] = useState({ isProductPrev: false, selectedProInfo: {} });
   const handleSelectedData = (item) => {
      setProductPreview({ isProductPrev: true, selectedProInfo: item })
   }
   const getFilteredProducts = (exhibitor, item) => {
      return (
         <div onClick={() => handleSelectedData(item)} >
            {item.data.new_product && <span className="gx-widget-badge-top-left-product badgeHeader">New Product</span>}
            <DetailCard
               key={item.id}
               imageSrc={item.data.feature_image}
               title={item.data.name}
               config={props.config}
               isNewProduct={item.data.new_product}
            />
         </div>

      )
   }
   const onDocumentLoadSuccess = (numPage) => {
      setNumPages(numPage.numPages);
   };
   const openPdf = (pdf) => {
      document.body.scrollTop += 0; //for safari
      setIsPdf(true);
      setPdfUrl(pdf);
   };
   return !ProductPrev.isProductPrev && !isPdf ? <div className='gx-mx-3'>
      {/* Products List */}
      {media && !_isEmpty(media.products) && (
         <div>
            <div className="gx-my-4 gx-d-flex" style={{ marginTop: 10, marginBottom: 10 }}>
               <SvgProductIcon className="modal-info-icon" color={props.customThemeStyle.primary_color} />
               <h3 className='app-text-color gx-m-0 gx-ml-4 gx-align-self-center font-weight-700'>Products</h3>
            </div>
            <Row className='gx-mx-4 gx-justify-content-evenly'>
               {media?.products.filter((item, index) => item.data?.new_product).map((item, index) => {
                  return <Col key={index} xl={7} lg={12} md={24} sm={24} xs={24}>
                     {getFilteredProducts(props, item)}
                  </Col>
               })}
               {media?.products.filter((item, index) => !item.data?.new_product).map((item, index) => {
                  return <Col key={index} xl={7} lg={12} md={24} sm={24} xs={24}>
                     {getFilteredProducts(media, item)}
                  </Col>
               })}
            </Row>
         </div>
      )}
      {/*  Links */}
      {media &&
         !_isEmpty(media.links) && (
            <div>
               <div className="gx-my-4 gx-d-flex">
                  <SvgLinkIcon className="modal-info-icon" color={props.customThemeStyle.primary_color} />
                  <h3 className='app-text-color gx-m-0 gx-ml-4 gx-align-self-center font-weight-700'>Links</h3>
               </div>
               <Row className='gx-mx-3'>
                  {media.links.map((item, index) => (
                     <Col key={index} span={24}>
                        <a href={
                           item.data.url.includes(
                              "http"
                           )
                              ? item.data.url
                              : "https://" +
                              item.data.url
                        }
                           target="_blank">
                           <h4
                              style={{ lineHeight: 3 }}
                              className='gx-text-left gx-text-black text-left gx-p-1 gx-m-1'>
                              <u><span className='gx-pb-2'>{item.data.label}</span></u>
                           </h4>
                        </a>
                     </Col>
                  ))}
               </Row>
            </div>
         )}
      {/*  PDF's List */}
      {media &&
         !_isEmpty(media.pdf) && (
            <div>
               <div className="gx-my-4 gx-d-flex">
                  <SvgPdfIcon className="modal-info-icon" color={props.customThemeStyle.primary_color} />
                  <h3 className='app-text-color gx-m-0 gx-ml-4 gx-align-self-center font-weight-700'>PDF's</h3>
               </div>
               <Row className='gx-mx-3 gx-justify-content-evenly'>
                  {media.pdf.map((item, index) => {
                     return (
                        <Col
                           key={index}
                           xl={7}
                           lg={12}
                           md={24}
                           sm={24}
                           xs={24}
                        >
                           <span className="gx-widget-badge-top-left-product badgeHeader">New PDF</span>
                           <DetailCard
                              key={index}
                              pdf={true}
                              documentUrl={item.data.url}
                              title={item.data.label}
                              onClick={() =>
                                 openPdf(item.data.url)
                              }
                              onLoadSuccess={
                                 onDocumentLoadSuccess
                              }
                              config={{}}
                           />
                        </Col>
                     );
                  })}
               </Row>
            </div>
         )}
      {/*  Videos */}
      {media &&
         media.youtube &&
         media.youtube.length > 0 && (
            <div>
               <div className="gx-my-4 gx-d-flex">
                  <SvgVideoIcon className="modal-info-icon" color={props.customThemeStyle.primary_color} />
                  <h3 className='app-text-color gx-m-0 gx-ml-4 gx-align-self-center font-weight-700'>Videos</h3>
               </div>
               <Row className='gx-mx-3 gx-justify-content-evenly'>
                  {!!(
                     media &&
                     media.youtube.length > 0
                  ) &&
                     media.youtube.map(
                        (item, index) => (
                           <Col className="gx-mt-4" key={index} xl={11} lg={12} md={24} sm={24} xs={24}>
                              <span className="gx-widget-badge-top-left-product badgeHeader">New Video</span>
                              <Card className="gx-card-widget card-shadow" style={{ borderRadius: 6 }}>
                                 <div style={{ height: 10 }}></div>
                                 <h4 className="gx-my-4 gx-text-left align-center resource-text-clr"> {item.data.title
                                    ? item.data.title
                                    : `Video ${index + 1
                                    }`}</h4>
                                 <div className="video-container">
                                    <ReactPlayer
                                       className="react-player"
                                       url={
                                          item.data
                                             .iframeHtml
                                       }
                                       height="70%"
                                       width="70%"
                                       controls
                                    />
                                 </div>
                              </Card>
                           </Col>
                        )
                     )}
               </Row>
            </div>
         )}
   </div> : ProductPrev.isProductPrev ? <div><ProductPreview exhibitor={props} data={ProductPrev.selectedProInfo} setProductPreview={setProductPreview} /></div> :
      <Row>
         <Col span={22} className='gx-ml-5'>
            <>
               <span className='pdfBack gx-pointer' onClick={() => setIsPdf(false)}>
                  <LeftOutlined />Back
               </span>
               <PDFObject url={pdfUrl}
                  height={"60vh"}
               />
            </>
         </Col>
      </Row>
}

export const StaffContact = (props) => {
   const recaptchaRef = useRef()
	const [isExtraSmallScreen, setIsExtraSmallScreen] = useState(false);
   const [selectedStaffmember, setSelectedStaffMember] = useState([props.contact_info[0]])
   const [staffListColumn, setStaffListColumn] = useState(24)
   const [staffMemberColumn, setStaffMemeberColumn] = useState(0)
   const [form, setForm] = useState({
      name: {
         value:"",
         error: ""
      },
      email: {
         value:"",
         error: ""
      },
      message:{
         value:"",
         error:""
      },
      captcha:{
         value:"",
         error:""
      }
   })
   const [isFormTouched, setIsFormTouched] = useState(false)
   const [loader, setLoader] = useState(false)
   const screenMinWidth = 868
   const screenWidth = window.screen.width ? window.screen.width : 0;

   const onCaptchaExpire = () => {
      let tempForm = {...form};
      tempForm['captcha'].value = ""
      tempForm['captcha'].error = "Captcha Expired. Please try again."
      setForm(tempForm);
   };

   const onCaptchaErrored = () => {
      let tempForm = {...form};
      tempForm['captcha'].value = ""
      tempForm['captcha'].error = "Something went wrong. Please try again."
      setForm(tempForm);
   };

   const settings = {
      arrows: false,
      dots: true,
      infinite: true,
      speed: 500,
      marginLeft: 0,
      marginRight: 0,
      slidesToShow: 1,
      slidesToScroll: 1
   };

   const validateForm = (form) => {
      let temp = {...form}
      let valid = true;

      if(!temp['name'].value){
         temp['name'].error = "Please enter your name"
         valid = false
      } else {
         temp['name'].error = ""
      }
      
      if(!temp['email'].value) {
         temp['email'].error = "Please enter your email"
         valid = false
      } else if(!temp['email'].value.match(/^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{1,15})$/)){
         temp['email'].error = "Please enter valid email"
         valid = false
      } else {
         temp['email'].error = ""
      }
      
      if(!temp['message'].value){
         temp['message'].error="Please enter a message"
         valid = false
      } else {
         temp['message'].error = ""
      }
      
      if(!temp['captcha'].value){
         temp['captcha'].error="Please check the box to proceed"
         valid = false
      } else {
         temp['captcha'].error = ""
      }

      return {form: temp, valid: valid}
   }

   const resetForm = () => {
      let temp = {...form}
      Object.keys(form).map(key => {
         temp[key].value = "";
         temp[key].error = "";
      })
      setForm(temp)
      setIsFormTouched(false)
   }

   const handleForm = (value, key) => {
      let tempForm = {...form};
      tempForm[key].value = value
      if(isFormTouched){
         let validatedForm = validateForm(form);
         tempForm = {...validatedForm.form}
      }
      setForm(tempForm);
   }

  const sendMessage = (contUUID) => {
    let validatedForm = validateForm(form);
    setForm(validatedForm.form);
    setIsFormTouched(true);
    if (validatedForm.valid) {
      setLoader(true);
      let data = {
        content: form["message"].value,
        ConferenceID: props.ConfID,
        message_contact_uuid:
          contUUID !== undefined && contUUID !== null && contUUID !== ""
            ? contUUID
            : "",
        method: "send_direct_message",
        name: form["name"].value,
        email: form["email"].value,
      };
      let url =
        "https://xcdsystem.com/masterapp_summer2012/controllers/company/api_user_interaction.cfm?source=" +
        props.source_hex +
        "&compId=" +
        props.CompUUID;
      let paramData = {
        method: "POST",
        body: JSON.stringify(data),
      };
      fetch(url, paramData)
        .then((res) => res.json())
        .then((response) => {
          NotificationManager.success(
            response[0].return_text,
            response[0].return_title
          );
          recaptchaRef.current.reset();
          setLoader(false);
          resetForm();
        })
        .catch((err) => {
          console.log(err);
          setLoader(false);
        });
    }
  };
  useEffect(() => {
    const reSizer = () => {
      setIsExtraSmallScreen(window.innerWidth <= 600);
    };
    reSizer();
    window.addEventListener("resize", reSizer);
    return window.removeEventListener("resize", () => {});
  }, []);
  // live site key : 6LeZ4qkZAAAAAA5G4kPEc-wb2_LjCPq-ssJOpzIJ
  // dev test key: 6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI
  const Captcha = useCallback(() => {
    return (
      <ReCAPTCHA
        ref={(ref) => (recaptchaRef.current = ref)}
        sitekey="6LeZ4qkZAAAAAA5G4kPEc-wb2_LjCPq-ssJOpzIJ"
        onChange={(e) => handleForm(e, "captcha")}
        onExpire={onCaptchaExpire}
        onErrored={onCaptchaErrored}
        badge="inline"
        size={isExtraSmallScreen ? "compact" : "normal"}
      />
    );
  }, [isExtraSmallScreen]);

  const handleStaffMember = (data) => {
     if (screenWidth < screenMinWidth && data) {
        setStaffListColumn(0)
        setStaffMemeberColumn(24)
     }
     if (data && data.uuid != selectedStaffmember[0].uuid) {
      const filteredData = props.contact_info.filter((item) => {
        return item.uuid === data.uuid;
      });
      setSelectedStaffMember(filteredData);
        resetForm();
    }
  };

   const renderListItem = () => {

      return (
        <List
          dataSource={props.contact_info}
          renderItem={(data, index) => (
            <List.Item
              key={index}
              onClick={() => handleStaffMember(data)}
                className="custom-ant-list-wapper"
                style={{ cursor: "pointer", padding: "5px" }}
            >
              <List.Item.Meta
                   className="custom-ant-list"
                avatar={
                  <Avatar
                    src={
                      data.picture
                        ? data.picture
                        : "https://ui-avatars.com/api/?name=" +
                          encodeURIComponent(
                            data.firstName + " " + data.lastName
                          ) +
                          "&size=128&background=red" +
                          "&color=ffffff"
                    }
                    alt="..."
                  />
                }
                title={data.lastName + " " + data.firstName}
                description={data.contactTitle ? data.contactTitle : ""}
              />
            </List.Item>
          )}
         />)
   }

   const formFields = () => {
      return (
         <>
            {screenWidth < screenMinWidth ?
               <Button
                  style={{ color: "black", marginBottom: "5px", fontSize: "14px" }}
                  icon={<LeftOutlined />}
                  type="link"
                  onClick={() => {
                     setStaffListColumn(24);
                     setStaffMemeberColumn(0);
                     resetForm();
                  }}
               >
                  Back
               </Button> : ""}
            {
               selectedStaffmember &&
               selectedStaffmember.map((data, index) => (
                  <div key={index}>
                     <Row style={{ padding: "10px 20px" }} className="staff-wrapper">
                        <Col className="gx-mr-0" style={{ padding: "0px" }}>
                  <div className="staffImg gx-mb-2">
                              <img
                                 height={"100px"}
                                 width={"100px"}
                                 // className={"gx-img-fluid"}
                                 style={{ borderRadius: "50px", objectFit: "cover" }}
                                 src={
                                    data.picture
                                       ? data.picture
                                       : "https://ui-avatars.com/api/?name=" +
                                       encodeURIComponent(
                                          data.firstName + " " + data.lastName
                                       ) +
                                       "&size=128&background=red" +
                                       "&color=ffffff"
                                 }
                                 alt="..."
                              />
                  </div>
                        </Col>
                        <Col
                  xl={20}
                  lg={18}
                  md={18}
                  sm={18}
                  xs={24}
                  className="gx-ml-0 gx-pl-3"

                        >
                  <h1 className="gx-mb-3 gx-mt-3 app-text-color staff-name font-weight-700">
                              {data.lastName + " " + data.firstName}
                  </h1>
                           <h1>{data.contactTitle}</h1>
                        </Col>

                        <Col style={{ width: "100%", marginTop: "15px" }}>
                           <div className="staffDetail" style={{ marginBottom: "15px" }}>
                              <div className="user-name-box-holder gx-mb-2">
                                 <Typography.Title
                                    level={5}
                                    className="required-field gx-mb-1"
                                 >
                                    Name:
                                 </Typography.Title>
                                 <Input
                                    type="text"
                                    size="middle"
                                    className="user-name-box border-black"
                                    id="name"
                                    onChange={(evt) => handleForm(evt.target.value, "name")}
                                    value={form.name.value}
                                    placeholder="Enter your name"
                                 ></Input>
                                 <p className="error-text">{form.name.error}</p>
                              </div>
                              <div className="user-email-box-holder gx-mb-2">
                                 <Typography.Title
                                    level={5}
                                    className="required-field gx-mb-1"
                                 >
                                    Email:
                                 </Typography.Title>
                                 <Input
                                    type="email"
                                    size="middle"
                                    className="user-email-box border-black"
                                    id="email"
                                    onChange={(evt) =>
                                       handleForm(evt.target.value, "email")
                                    }
                                    value={form.email.value}
                                    placeholder="Enter your email"
                                 ></Input>
                                 <p className="error-text">{form.email.error}</p>
                              </div>
                              <div className="user-message-box-holder gx-mb-4">
                                 <Typography.Title
                                    level={5}
                                    className="required-field gx-mb-1"
                                 >
                                    Message:
                                 </Typography.Title>
                                 <TextArea
                                    placeholder={"Compose Message to " + data.firstName}
                                    autoSize={{ minRows: 4, maxRows: 4 }}
                                    onChange={(event) =>
                                       handleForm(event.target.value, "message")
                                    }
                                    value={form.message.value}
                                    className="user-msg-box border-black"
                                    style={{
                                       border: "0.5px solid black",
                                       fontSize: "large",
                                       height: "100px",

                                    }}
                                 />
                                 <p className="error-text">{form.message.error}</p>
                              </div>
                              <div className="user-captcha-box-holder gx-mb-2">
                                 <Captcha />
                                 <p className="error-text">{form.captcha.error}</p>
                              </div>
                              <Button
                                 disabled={loader}
                                 shape="round"
                                 className="gx-mb-0 gx-mt-3 staff-send-btn"
                                 htmlType="submit"
                                 onClick={() => sendMessage(data.uuid)}
                              >
                                 <h4 className="staff-btn-text" style={{ marginBottom: "0px" }}>Send Message</h4>
                              </Button>
                              {screenWidth < screenMinWidth ?
                                 <Button
                                    disabled={loader}
                                    shape="round"
                                    className="gx-mb-0 gx-mt-3 staff-send-btn"
                                    htmlType="submit"
                                    onClick={() => {
                                       setStaffListColumn(24);
                                       setStaffMemeberColumn(0);
                                       resetForm();
                                    }}
                                 >
                                    <h4 className="staff-btn-text" style={{ marginBottom: "0px" }}>Cancel</h4>
                                 </Button> : ""}
                  </div>
                        </Col>
                     </Row>
            </div>
               ))
            }

         </>
      )
   }

   return (
      <>
         <Row gutter={0}>
            <Col lg={7} xxl={7} md={staffListColumn} sm={staffListColumn} xs={staffListColumn}
               style={{
                  maxHeight: "595px",
                  minHeight: "300px",
                  overflowY: "auto",
                  paddingRight: "0px",
                  borderRight: "1px solid lightgrey"
               }}>
               {renderListItem()}
            </Col>

            <Col lg={17} xxl={17} md={staffMemberColumn} sm={staffMemberColumn} xs={staffMemberColumn}
               style={{
                  maxHeight: "595px",
                  minHeight: "300px",
                  overflowY: "auto"
               }}>
               {formFields()}
            </Col>
         </Row>
      </>
   )
};
